// Client-side Liquid syntax validation.
// Uses liquidjs's parser only — does not execute templates.
// Returns null on valid input, or { message, line, col } on parse error.

import { Liquid } from "liquidjs";

const engine = new Liquid({
  // Render-time options don't matter for parse-only validation,
  // but keep strict modes off so that referencing undefined vars
  // (which is normal for templates) is allowed.
  strictFilters: false,
  strictVariables: false,
});

// Strip HTML tags to plain text + Liquid tokens before parsing.
// liquidjs treats unknown HTML as literal output, but tag/attribute
// noise can confuse line counting in error messages — plain text
// gives sharper feedback to the user.
function htmlToText(html) {
  if (!html) return "";
  if (typeof DOMParser === "undefined") return html;
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body ? doc.body.textContent || "" : html;
}

export function validateLiquid(html) {
  const text = htmlToText(html);
  if (!text || (!text.includes("{{") && !text.includes("{%"))) return null;

  try {
    engine.parse(text);
    return null;
  } catch (e) {
    const msg = (e && (e.message || e.toString())) || "Liquid parse error";
    // liquidjs error shape exposes line/col on `.line` / `.col`
    return {
      message: msg.split("\n")[0].slice(0, 200),
      line: e?.line ?? null,
      col: e?.col ?? null,
    };
  }
}
